import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

// User data is already loaded by AuthContext on app init — no need to re-fetch here
const AccountLayout = ({ children }) => {
    const location = useLocation();
    const { language } = useLanguage();
    // All account sub-pages (orders, victories, blog, faq, about, privacy, etc.)
    // link back to /dashboard/account. The root /dashboard/account itself hides the back link.
    const isAccountRoot = location.pathname === '/dashboard/account' || location.pathname === '/dashboard/account/';
    const showBack = !isAccountRoot;
    const backTo = '/dashboard/account';
    const backLabel = language === 'fr' ? 'Mon compte' : 'My account';

    return (
        <div className="bg-gray-50 dark:bg-[#0a0a0a] text-gray-900 dark:text-white min-h-full transition-colors duration-300">
            <main className="w-full bg-gray-50 dark:bg-[#0a0a0a] transition-colors duration-300">
                <div className="max-w-7xl mx-auto px-[10%] py-6 md:py-12">
                    {showBack && (
                        <Link
                            to={backTo}
                            className="inline-flex items-center gap-1.5 mb-6 text-sm font-medium text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                        >
                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                            </svg>
                            {backLabel}
                        </Link>
                    )}
                    {children}
                </div>
            </main>
        </div>
    );
};

export default AccountLayout;
